export default "__VITE_ASSET__CciA9ATO__"